import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { LinkIcon, CodeIcon, ZapIcon, Heading1Icon, CheckCircle2Icon, InfoIcon } from 'lucide-react';
const FixGroup = ({
  icon: Icon,
  title,
  items
}: {
  icon: any;
  title: string;
  items: string[];
}) => <div className="glass-card p-4 sm:p-6" data-id="element-339">
    <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-5 pb-3 sm:pb-4 border-b border-slate-200" data-id="element-340">
      <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-slate-100 flex items-center justify-center" data-id="element-341">
        <Icon className="w-4 h-4 sm:w-5 sm:h-5 text-gold-600" data-id="element-342" />
      </div>
      <h3 className="text-base sm:text-xl font-bold text-slate-900" data-id="element-343">{title}</h3>
    </div>
    <ul className="space-y-2 sm:space-y-3" data-id="element-344">
      {items.map((item, i) => <li key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-345">
          <CheckCircle2Icon className="w-4 h-4 sm:w-5 sm:h-5 text-green-500 shrink-0 mt-0.5" data-id="element-346" />
          <span className="text-xs sm:text-base text-slate-600" data-id="element-347">{item}</span>
        </li>)}
    </ul>
  </div>;
export function TechnicalFixes() {
  return <SlideLayout data-id="element-348">
      <div className="mb-6 sm:mb-10" data-id="element-349">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-350" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-351">
          Technical SEO Fixes
        </h2>
        <p className="text-sm sm:text-xl text-slate-500" data-id="element-352">
          Resolving these technical issues improves crawlability, rankings, and
          user experience.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-6 mb-4 sm:mb-8" data-id="element-353">
        <FixGroup icon={LinkIcon} title="On-Site SEO" items={['Get 1–2 backlinks from high-quality websites (good DR/DA, organic traffic, low spam)', 'High-quality backlinks inform search engines about trust and authority', 'Positively affects organic traffic and website awareness', 'Focus on valuable websites with relevant audience']} data-id="element-354" />
        <FixGroup icon={CodeIcon} title="Off-Site SEO" items={['Add schema markup for content structure', 'Optimize site speed (especially mobile)', 'Fix missing alt text on images', 'Address redirect issues (3XX status codes)']} data-id="element-355" />
        <FixGroup icon={Heading1Icon} title="Content Structure" items={['Optimize H1 tags (fix missing and multiple H1s)', 'Improve internal linking strategy', 'Fix broken and nofollow external links', 'Minify JavaScript and compress CSS files']} data-id="element-356" />
        <FixGroup icon={ZapIcon} title="Performance" items={['Improve mobile page speed (currently 61/100)', 'Reduce number of JavaScript files', 'Fix external CSS files with error status codes', 'Optimize Core Web Vitals metrics']} data-id="element-357" />
      </div>

      <div className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 rounded-xl bg-blue-50 border border-blue-200" data-id="element-358">
        <InfoIcon className="w-5 h-5 sm:w-6 sm:h-6 text-blue-500 shrink-0 mt-0.5" data-id="element-359" />
        <p className="text-xs sm:text-sm text-blue-900 leading-relaxed" data-id="element-360">
          <strong className="font-semibold text-slate-900" data-id="element-361">
            Technical SEO forms the foundation.
          </strong>{' '}
          These fixes ensure search engines can properly crawl, index, and rank
          your content, maximizing the ROI of all other marketing efforts.
        </p>
      </div>
    </SlideLayout>;
}